import { Table } from "@mantine/core";

export default {
  Table: Table.extend({
    defaultProps: {
      highlightOnHover: true,
    },
  }),
};
